import { IComponent } from 'src/common/helpers/handleFunctions';

let instance: RenderedComponentsSingleton | undefined;

class RenderedComponentsSingleton {

	private renderedComponents: (Omit<IComponent<object>, 'id' | 'props'> & { name: string, props: string[] })[] = [];

	constructor(){
		if(!instance){
			//eslint-disable-next-line @typescript-eslint/no-this-alias
			instance = this;
		}else{
			return instance;
		}
	}

	public subscribeComponent(component: (Omit<IComponent<object>, 'id' | 'props'> & { name: string, props: string[] })): void {
		if(
			this.renderedComponents.find(_component => 
				JSON.stringify(_component.props) 
                == JSON.stringify(component.props))
		){
			return;
		}
		this.renderedComponents.push(component);
	}
    
	public getComponents(): (Omit<IComponent<object>, 'id' | 'props'> & { name: string, props: string[] })[] {
		return this.renderedComponents;
	}
}

export default Object.freeze(RenderedComponentsSingleton);